import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

type Variant = "primary" | "secondary" | "tertiary";

const Button: React.FC<{
  variant?: Variant;
  text?: string;
  onClick?: any;
  className?: string;
  to?: string; // Add a 'to' prop for routing
  disabled?: boolean;
}> = ({
  variant = "primary",
  text = "Button",
  onClick = () => {},
  className = "",
  to, // Destructure the 'to' prop
  disabled = false,
}) => {
  // Define base styles and variants
  const baseStyles = `
    px-4 py-2
    font-bold text-center
    rounded-lg transition-all duration-300
  `;

  const variantStyles: Record<Variant, string> = {
    primary: "bg-[#D32626] text-[#FFFFFF] hover:opacity-90",
    secondary: "bg-[#4D4D4D] text-[#FFFFFF] hover:opacity-90",
    tertiary: "bg-[#F6F6F6] text-[#000000] border font-bold",
  };

  const selectedVariant = variantStyles[variant] || variantStyles.primary;

  if (to) {
    return (
      <Link
        to={to}
        className={`${baseStyles} ${selectedVariant} ${className} ${
          disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
        }`}
      >
        {text}
      </Link>
    );
  }

  return (
    <button
      className={`${baseStyles} ${selectedVariant} ${className} ${
        disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
      }`}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

// PropTypes for validation
Button.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
  text: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  to: PropTypes.string, // Validate the 'to' prop
};

export default Button;
